import React from 'react';
import './terms.scss'
interface Props {
	show: boolean,
	hide: (show: boolean) => void
}
function Gdpr({show, hide}: Props) {
	return (
		<div>
			{show && <div className="modal fade" id='gdpr-modal' data-backdrop="static" data-keyboard="false" tabIndex={-1}
                    aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div className="modal-dialog">
              <div className="modal-content">
                  <div className="modal-body">
                      <iframe className="frameBorder" src="https://www.bgradio.bg/page/nppd"
                        name="rules" height="400"
                        width="100%" allowFullScreen />
                  </div>
                  <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => hide(!show)}>Затвори</button>
                  </div>
              </div>
          </div>
      </div>}
		</div>
	);
}

export default Gdpr;